import React from "react";
import { FaArrowRight, FaCar, FaMapMarkerAlt } from "react-icons/fa"
import { MdBathroom, MdBedroomChild } from "react-icons/md";
import { Container, Image, Descricao, Itens } from "./styles";
import indisponivel from "../../assets/indisponivel.jpg";

const Card = ({ imovel }) => {
  const {
    tipo,
    finalidade,
    cidade,
    valor,
    quartos,
    banheiros,
    vagas,
    slug
  } = imovel;

  const getImagemPrincipal = (imagem) => {
    if (!imagem) return indisponivel;
    return `${process.env.REACT_APP_API_URL}/uploads/${imagem.split("uploads/")[1]}`;
  };

  return (
    <Container>
      <Image>
        <img
          src={getImagemPrincipal(imovel.imagem_principal)}
          alt={`Imagem do imóvel ${tipo}`}
        />
      </Image>
      <Descricao>
        <h4>{tipo} - {finalidade}</h4>
        <span className="local">
          <FaMapMarkerAlt /> {cidade}
        </span>
        <Itens>
          <span><MdBedroomChild size={24} /> {quartos} Dormitórios</span>
          <span><MdBathroom size={24} /> {banheiros} Banheiros</span>
          <span><FaCar size={24} /> {vagas} Vagas</span>
        </Itens>
        <div className="valor">R$ {parseFloat(valor).toLocaleString("pt-BR", { minimumFractionDigits: 2 })}</div>
        <a href={`/imovel/${slug}`}>Detalhes <FaArrowRight /></a>
      </Descricao>
    </Container>
  );
};

export default Card;
